import { render, staticRenderFns } from "./Listings.vue?vue&type=template&id=19796a06&lang=pug"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports